"use strict";

var _interopRequireDefault = require("@babel/runtime/helpers/interopRequireDefault").default;
Object.defineProperty(exports, "__esModule", {
  value: true
});
exports.default = void 0;
require("core-js/modules/es6.array.slice.js");
var _regeneratorRuntime2 = _interopRequireDefault(require("@babel/runtime/helpers/regeneratorRuntime"));
var _asyncToGenerator2 = _interopRequireDefault(require("@babel/runtime/helpers/asyncToGenerator"));
var _classCallCheck2 = _interopRequireDefault(require("@babel/runtime/helpers/classCallCheck"));
var _createClass2 = _interopRequireDefault(require("@babel/runtime/helpers/createClass"));
// a basic in memory queue with an asynchronous api
var MemoryQueueAsync = /*#__PURE__*/function () {
  function MemoryQueueAsync() {
    (0, _classCallCheck2.default)(this, MemoryQueueAsync);
    this.queue = [];
  }
  (0, _createClass2.default)(MemoryQueueAsync, [{
    key: "enqueue",
    value: function () {
      var _enqueue = (0, _asyncToGenerator2.default)( /*#__PURE__*/(0, _regeneratorRuntime2.default)().mark(function _callee() {
        var _this$queue;
        var _args = arguments;
        return (0, _regeneratorRuntime2.default)().wrap(function _callee$(_context) {
          while (1) {
            switch (_context.prev = _context.next) {
              case 0:
                return _context.abrupt("return", (_this$queue = this.queue).push.apply(_this$queue, _args));
              case 1:
              case "end":
                return _context.stop();
            }
          }
        }, _callee, this);
      }));
      function enqueue() {
        return _enqueue.apply(this, arguments);
      }
      return enqueue;
    }()
  }, {
    key: "dequeue",
    value: function () {
      var _dequeue = (0, _asyncToGenerator2.default)( /*#__PURE__*/(0, _regeneratorRuntime2.default)().mark(function _callee2() {
        var limit,
          _args2 = arguments;
        return (0, _regeneratorRuntime2.default)().wrap(function _callee2$(_context2) {
          while (1) {
            switch (_context2.prev = _context2.next) {
              case 0:
                limit = _args2.length > 0 && _args2[0] !== undefined ? _args2[0] : null;
                if (limit) {
                  _context2.next = 3;
                  break;
                }
                return _context2.abrupt("return", this.queue.splice(0, this.queue.length));
              case 3:
                if (!(typeof limit !== 'number')) {
                  _context2.next = 5;
                  break;
                }
                throw new Error('queue.dequeue: first argument must be a number');
              case 5:
                if (!(limit < 0)) {
                  _context2.next = 7;
                  break;
                }
                throw new Error('queue.dequeue: cannot dequeue a negative number of items');
              case 7:
                return _context2.abrupt("return", this.queue.splice(0, limit));
              case 8:
              case "end":
                return _context2.stop();
            }
          }
        }, _callee2, this);
      }));
      function dequeue() {
        return _dequeue.apply(this, arguments);
      }
      return dequeue;
    }()
  }, {
    key: "toArray",
    value: function () {
      var _toArray = (0, _asyncToGenerator2.default)( /*#__PURE__*/(0, _regeneratorRuntime2.default)().mark(function _callee3() {
        return (0, _regeneratorRuntime2.default)().wrap(function _callee3$(_context3) {
          while (1) {
            switch (_context3.prev = _context3.next) {
              case 0:
                return _context3.abrupt("return", this.queue.slice());
              case 1:
              case "end":
                return _context3.stop();
            }
          }
        }, _callee3, this);
      }));
      function toArray() {
        return _toArray.apply(this, arguments);
      }
      return toArray;
    }()
  }]);
  return MemoryQueueAsync;
}();
exports.default = MemoryQueueAsync;
//# sourceMappingURL=data:application/json;charset=utf-8;base64,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